import React, { useState } from 'react';
import { CheckIcon, InfoIcon, TruckIcon, PackageIcon, XIcon, ImageIcon, UploadIcon } from 'lucide-react';
const PriceList = () => {
  const [showModal, setShowModal] = useState(false);
  const [serviceType, setServiceType] = useState('');
  const [files, setFiles] = useState([]);
  const openModal = type => {
    setServiceType(type);
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setFiles([]);
  };
  const handleFileChange = e => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFiles(prev => [...prev, ...newFiles]);
    }
  };
  const removeFile = index => {
    setFiles(files.filter((_, i) => i !== index));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Siia tuleks päris saatmise loogika
    alert('Päring saadetud! Täname teid ja võtame peagi ühendust.');
    closeModal();
  };
  return <section className="py-16 bg-gray-50" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <h2 className="text-3xl font-bold text-center mb-3 text-gray-900" data-id="element-189">
          Hinnakiri
        </h2>
        <p className="text-center text-gray-600 mb-10" data-id="element-190">
          Kõik hinnad sisaldavad käibemaksu. Valige allpool endale sobiv
          teenusepakett.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-191">
          {/* Paigalduse kaart */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-192">
            <div className="bg-blue-900 px-6 py-4" data-id="element-193">
              <div className="flex items-center" data-id="element-194">
                <PackageIcon size={24} className="text-white mr-3" data-id="element-195" />
                <h3 className="text-xl font-bold text-white" data-id="element-196">
                  Mööbli kokkupanek ja paigaldus
                </h3>
              </div>
            </div>
            <div className="p-6" data-id="element-197">
              <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4" data-id="element-198">
                <div data-id="element-199">
                  <p className="text-lg font-medium text-gray-900" data-id="element-200">
                    Mööbli kokkupanemine
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-201">Tööaeg tund</p>
                </div>
                <p className="text-2xl font-bold text-blue-900" data-id="element-202">35€/h</p>
              </div>
              <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4" data-id="element-203">
                <div data-id="element-204">
                  <p className="text-lg font-medium text-gray-900" data-id="element-205">
                    Paigaldustööd
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-206">Tööaeg tund</p>
                </div>
                <p className="text-2xl font-bold text-blue-900" data-id="element-207">45€/h</p>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-208">
                <li className="flex items-start" data-id="element-209">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-210" />
                  <span className="text-gray-700" data-id="element-211">
                    Minimaalne tellimus 2 tundi
                  </span>
                </li>
                <li className="flex items-start" data-id="element-212">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-213" />
                  <span className="text-gray-700" data-id="element-214">Töötame 7 päeva nädalas</span>
                </li>
                <li className="flex items-start" data-id="element-215">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-216" />
                  <span className="text-gray-700" data-id="element-217">
                    Esmaspäevast reedeni: 35€/h
                  </span>
                </li>
                <li className="flex items-start" data-id="element-218">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-219" />
                  <span className="text-gray-700" data-id="element-220">
                    Nädalavahetusel ja riigipühadel: 50€/h
                  </span>
                </li>
                <li className="flex items-start" data-id="element-221">
                  <InfoIcon size={20} className="text-blue-500 mr-2 mt-1 flex-shrink-0" data-id="element-222" />
                  <span className="text-gray-700" data-id="element-223">
                    Hind sisaldab 1 mööblikokkupanijat või paigaldajat
                  </span>
                </li>
              </ul>
              <div className="bg-blue-50 p-4 rounded-md" data-id="element-224">
                <p className="text-sm text-gray-700 font-medium" data-id="element-225">
                  Kokkupanija definatsioon:
                </p>
                <p className="text-sm text-gray-600 mt-1" data-id="element-226">
                  Mööbli kokkupanija paneb mööblit kokku, et see oleks
                  kasutusvalmis vastavalt tootja juhistele.
                </p>
              </div>
            </div>
            <div className="px-6 pb-6" data-id="element-227">
              <button onClick={() => openModal('kokkupanek')} className="w-full bg-blue-900 text-white py-3 px-4 rounded-md hover:bg-blue-800 transition duration-300" data-id="element-228">
                Küsi pakkumist
              </button>
            </div>
          </div>
          {/* Kolimise kaart */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-229">
            <div className="bg-blue-900 px-6 py-4" data-id="element-230">
              <div className="flex items-center" data-id="element-231">
                <TruckIcon size={24} className="text-white mr-3" data-id="element-232" />
                <h3 className="text-xl font-bold text-white" data-id="element-233">
                  Mööbli transport ja kolimine
                </h3>
              </div>
            </div>
            <div className="p-6" data-id="element-234">
              <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4" data-id="element-235">
                <div data-id="element-236">
                  <p className="text-lg font-medium text-gray-900" data-id="element-237">
                    Kolimisteenus
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-238">Tööaeg tund</p>
                </div>
                <p className="text-2xl font-bold text-blue-900" data-id="element-239">70€/h</p>
              </div>
              <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4" data-id="element-240">
                <div data-id="element-241">
                  <p className="text-lg font-medium text-gray-900" data-id="element-242">Transport</p>
                  <p className="text-sm text-gray-600" data-id="element-243">Tööaeg tund</p>
                </div>
                <p className="text-2xl font-bold text-blue-900" data-id="element-244">40€/h</p>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-245">
                <li className="flex items-start" data-id="element-246">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-247" />
                  <span className="text-gray-700" data-id="element-248">
                    Minimaalne tellimus 1 tund
                  </span>
                </li>
                <li className="flex items-start" data-id="element-249">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-250" />
                  <span className="text-gray-700" data-id="element-251">
                    Hind sisaldab kahte kolijat ja kaubikut
                  </span>
                </li>
                <li className="flex items-start" data-id="element-252">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-253" />
                  <span className="text-gray-700" data-id="element-254">
                    Kaubiku kandevõime kuni 1200 kg
                  </span>
                </li>
                <li className="flex items-start" data-id="element-255">
                  <CheckIcon size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-256" />
                  <span className="text-gray-700" data-id="element-257">Töötame 7 päeva nädalas</span>
                </li>
                <li className="flex items-start" data-id="element-258">
                  <InfoIcon size={20} className="text-blue-500 mr-2 mt-1 flex-shrink-0" data-id="element-259" />
                  <span className="text-gray-700" data-id="element-260">
                    Hind ei sisalda pakkematerjali ja eritõstetöid
                  </span>
                </li>
              </ul>
              <div className="bg-blue-50 p-4 rounded-md" data-id="element-261">
                <p className="text-sm text-gray-700 font-medium" data-id="element-262">
                  Koostööpartneritele soodustused!
                </p>
                <p className="text-sm text-gray-600 mt-1" data-id="element-263">
                  Pakume püsiklientidele ja koostööpartneritele soodsamaid
                  hindu. Küsi pakkumist!
                </p>
              </div>
            </div>
            <div className="px-6 pb-6" data-id="element-264">
              <button onClick={() => openModal('transport')} className="w-full bg-blue-900 text-white py-3 px-4 rounded-md hover:bg-blue-800 transition duration-300" data-id="element-265">
                Küsi pakkumist
              </button>
            </div>
          </div>
        </div>
        {/* Pakkumise küsimise modal */}
        {showModal && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-266">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" data-id="element-267">
              <div className="flex justify-between items-center bg-blue-900 text-white px-6 py-4 rounded-t-lg" data-id="element-268">
                <h3 className="text-xl font-bold" data-id="element-269">
                  {serviceType === 'kokkupanek' ? 'Küsi pakkumist mööbli kokkupaneku ja paigalduse kohta' : 'Küsi pakkumist mööbli transpordi ja kolimise kohta'}
                </h3>
                <button onClick={closeModal} className="text-white hover:text-gray-200" data-id="element-270">
                  <XIcon size={24} data-id="element-271" />
                </button>
              </div>
              <form onSubmit={handleSubmit} className="p-6" data-id="element-272">
                <div className="mb-4" data-id="element-273">
                  <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-274">
                    E-post *
                  </label>
                  <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-275" />
                </div>
                <div className="mb-4" data-id="element-276">
                  <label htmlFor="address" className="block text-sm font-medium mb-1" data-id="element-277">
                    Tööde aadress *
                  </label>
                  <input type="text" id="address" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tänav, maja, korter, linn" required data-id="element-278" />
                </div>
                <div className="mb-4" data-id="element-279">
                  <label htmlFor="description" className="block text-sm font-medium mb-1" data-id="element-280">
                    Kirjeldus/mõtted/küsimused/ideed *
                  </label>
                  <textarea id="description" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Kirjeldage oma soove ja vajadusi võimalikult täpselt" required data-id="element-281"></textarea>
                </div>
                <div className="mb-6" data-id="element-282">
                  <label className="block text-sm font-medium mb-2" data-id="element-283">
                    Piltide lisamine
                  </label>
                  <div className="mb-3" data-id="element-284">
                    <div className="flex items-center justify-center w-full" data-id="element-285">
                      <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer border-gray-300 bg-gray-50 hover:bg-gray-100" data-id="element-286">
                        <div className="flex flex-col items-center justify-center pt-5 pb-6" data-id="element-287">
                          <UploadIcon size={32} className="text-gray-400 mb-2" data-id="element-288" />
                          <p className="mb-2 text-sm text-gray-500" data-id="element-289">
                            <span className="font-semibold" data-id="element-290">
                              Kliki failide lisamiseks
                            </span>{' '}
                            või lohista failid siia
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-291">
                            PNG, JPG või JPEG (max 10MB)
                          </p>
                        </div>
                        <input type="file" className="hidden" multiple accept="image/png, image/jpeg, image/jpg" onChange={handleFileChange} data-id="element-292" />
                      </label>
                    </div>
                  </div>
                  {files.length > 0 && <div className="mt-3" data-id="element-293">
                      <p className="text-sm font-medium mb-2" data-id="element-294">
                        Lisatud pildid:
                      </p>
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-id="element-295">
                        {files.map((file, index) => <div key={index} className="relative group" data-id="element-296">
                            <div className="h-24 rounded-md bg-gray-100 flex items-center justify-center border border-gray-200 overflow-hidden" data-id="element-297">
                              <div className="absolute inset-0 flex items-center justify-center" data-id="element-298">
                                {file.type.startsWith('image/') ? <img src={URL.createObjectURL(file)} alt={`Upload ${index + 1}`} className="h-full w-full object-cover" data-id="element-299" /> : <ImageIcon size={24} className="text-gray-400" data-id="element-300" />}
                              </div>
                              <button type="button" onClick={() => removeFile(index)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-301">
                                <XIcon size={16} data-id="element-302" />
                              </button>
                            </div>
                            <p className="text-xs truncate mt-1" data-id="element-303">{file.name}</p>
                          </div>)}
                      </div>
                    </div>}
                </div>
                <div className="flex justify-end" data-id="element-304">
                  <button type="button" onClick={closeModal} className="mr-2 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-305">
                    Tühista
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800" data-id="element-306">
                    Saada päring
                  </button>
                </div>
              </form>
            </div>
          </div>}
      </div>
    </section>;
};
export default PriceList;